import { Route, Routes } from "react-router-dom";
import { BytecodeHashPage } from "./pages/BytecodeHashPage";
import { BytecodeRepositoryPage } from "./pages/BytecodeRepositoryPage";
import { BytecodeTypePage } from "./pages/BytecodeTypePage";
import { LegalPage } from "./pages/LegalPage";
import { NotFoundPage } from "./pages/NotFoundPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<BytecodeRepositoryPage />} />
      <Route path="/hash/:hash" element={<BytecodeHashPage />} />
      <Route
        path="/type/:contractType/:version"
        element={<BytecodeTypePage />}
      />
      <Route path="/legal/:slug" element={<LegalPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
